import { render, staticRenderFns } from "./ServiceTab.vue?vue&type=template&id=4d7c659e&scoped=true&"
import script from "./ServiceTab.vue?vue&type=script&lang=js&"
export * from "./ServiceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c659e",
  null
  
)

export default component.exports